import { defineMessages, type MessageDescriptor } from 'react-intl'
import {
  TOUR_V2_PACKAGE_OPTION_BASE,
  TOUR_V2_PACKAGE_OPTION_EXTENDED,
  TOUR_V2_PACKAGE_OPTION_EXTENDED_ALTERNATIVE,
} from 'constants/tours'

export const FLIGHT_PACKAGE_TOUR_ID = 'tour-dfbb7970-030b-4ba8-8c6d-b2fc83e3979d'

// This tour needs cabin-class labels rather than the generic Base/Extension
// labels. Keep the display override separate from the booking option names.
const tourVariationLabelOverrides: Partial<Record<string, Partial<Record<string, MessageDescriptor>>>> = {
  [FLIGHT_PACKAGE_TOUR_ID]: defineMessages({
    [TOUR_V2_PACKAGE_OPTION_BASE]: {
      id: 'UnfGFHM_QqnNcniNDNaT',
      defaultMessage: 'Economy',
      description: 'Tour option label for the economy flight package on this tour',
    },
    [TOUR_V2_PACKAGE_OPTION_EXTENDED]: {
      id: 'jgO9C9OmoDQ2e_jgo6iy',
      defaultMessage: 'Economy Plus',
      description: 'Tour option label for the economy plus flight package on this tour',
    },
    [TOUR_V2_PACKAGE_OPTION_EXTENDED_ALTERNATIVE]: {
      id: 'MPFDzS1pPVI94Ix7gxVk',
      defaultMessage: 'Business Class',
      description: 'Tour option label for the business class flight package on this tour',
    },
  }),
}

export default tourVariationLabelOverrides
